import * as React from 'react'
import { Button } from '..'
import { Twitter } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { blue } from '@material-ui/core/colors'
import clsx from 'clsx'

const TwitterButton = ({ onClick, children, className, disabled }) => {
  const s = useStyle()

  return (
    <Button
      variant="contained"
      startIcon={<Twitter />}
      className={clsx(s.button, className)}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}

const useStyle = makeStyles({
  button: {
    backgroundColor: blue[400],
    color: '#FFF',
    '&:hover': {
      backgroundColor: blue[300],
    },
    textTransform: 'none',
  },
})

export default TwitterButton
